import React from 'react';
import { G, Path } from 'react-native-svg';

import { IconDef } from './types';

export const Phone: IconDef = {
  svg: (
    <G>
      <Path
        d="M7.85913 8.99788C8.6073 10.4475 9.6272 11.8061 10.9188 13.0077C12.2105 14.2093 13.671 15.1581 15.2292 15.8541C15.3633 15.914 15.4303 15.9439 15.5151 15.9669C15.8165 16.0486 16.1865 15.9899 16.4417 15.8199C16.5136 15.7721 16.575 15.7149 16.6979 15.6006C17.0737 15.251 17.2616 15.0762 17.4506 14.9619C18.1631 14.5309 19.0818 14.5309 19.7943 14.9619C19.9833 15.0762 20.1712 15.251 20.547 15.6006L20.7565 15.7955C21.3278 16.3269 21.6134 16.5926 21.7686 16.878C22.0771 17.4456 22.0771 18.1158 21.7686 18.6834C21.6134 18.9688 21.3278 19.2345 20.7565 19.7659L20.587 19.9236C20.0177 20.4532 19.7331 20.718 19.346 20.9202C18.9166 21.1447 18.2496 21.306 17.757 21.3047C17.3131 21.3034 17.0097 21.2233 16.403 21.0631C13.1422 20.2022 10.0653 18.5777 7.49836 16.1897C4.93139 13.8017 3.18516 10.9394 2.25965 7.90597C2.08744 7.34152 2.00133 7.0593 2.00001 6.64635C1.99854 6.18813 2.172 5.56764 2.41324 5.16813C2.63065 4.8081 2.91531 4.54329 3.48463 4.01366L3.65408 3.85603C4.22535 3.32459 4.51099 3.05887 4.81776 2.91452C5.42787 2.62745 6.14837 2.62745 6.75847 2.91452C7.06524 3.05887 7.35088 3.32459 7.92216 3.85603L8.13163 4.0509C8.50744 4.40051 8.69535 4.57531 8.8182 4.75109C9.2815 5.41398 9.2815 6.26856 8.8182 6.93145C8.69535 7.10723 8.50744 7.28203 8.13163 7.63163C8.00875 7.74595 7.94731 7.8031 7.89588 7.86992C7.71313 8.10735 7.65003 8.4516 7.73788 8.73196C7.7626 8.81085 7.79478 8.87319 7.85913 8.99788Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
  ),
  svgStyles(color) {
    return {
      stroke: color,
    };
  },
};
